import React, { FC, ReactElement } from 'react'
import { CANCELLATION_POLICY } from '../../../utils/constants/StaticLinks'
import './appointment.scss'

const AppointmentFooter: FC<{}> = (): ReactElement => {
  return (
    <div className="policy-text">
      By confirming your appointment you're agreeing
      <br />
      to our{' '}
      <a href={CANCELLATION_POLICY} target="_blank" rel="noreferrer">
        Cancellation Policy.
      </a>
    </div>
  )
}

export default React.memo(AppointmentFooter)
